// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lFR9xtPk1QnLeY7db1YgT"};